//import ThemeButton from "components/Buttons/ThemeButton";
import ThemeButton from "components/Buttons/ThemeButton";
import styled from "styled-components";

export const Container = styled.div<{ scale: number }>`
	font-size: 17px;
	width: 21.375em;
	height: 28.0625em;
	background-color: white;
	border-radius: 16px;
	overflow: hidden;
	transform: scale(${(props) => props.scale});

	display: flex;
	flex-direction: column;
	align-items: center;

	@media (orientation: landscape) {
		flex-direction: row;
		font-size: 16px;
		width: 59.75em;
		height: 25.625em;
	}
`;

export const Header = styled.div`
	position: relative;
	height: 42%;
	width: 100%;
	background-color: #c7c7c7;
	display: flex;
	align-items: center;
	justify-content: center;
	color: rgba(0, 0, 0, 0.25);
	font-family: Inter;
	font-weight: 700;
	font-size: 1em;
	text-transform: uppercase;
	letter-spacing: 0.15em;

	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;

	@media (orientation: landscape) {
		height: 100%;
		width: 50%;
	}
`;

export const Body = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	flex-direction: column;
	width: 90%;
	height: 58%;
	gap: 0.8em;

	@media (orientation: landscape) {
		width: 50%;
		height: 100%;
		gap: 0.4em;
	}
`;

export const Title = styled.div`
	color: #333;
	text-align: center;
	font-family: Baloo;
	font-size: 2em;
	font-style: normal;
	font-weight: 400;
	line-height: 0.9em;

	@media (orientation: landscape) {
		font-size: 3em;
		margin-top: 0.6em;
	}
`;

export const SubTitle = styled.div`
	color: #333;
	text-align: center;
	font-family: Inter;
	font-size: 1em;
	font-style: normal;
	font-weight: 700;
	line-height: 1.2em;

	@media (orientation: landscape) {
		margin-top: 0.7em;
		font-size: 1.25em;
	}
`;

export const ButtonsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8em;
	justify-content: center;
	align-items: center;
	margin-top: 1.5em;

	@media (orientation: landscape) {
		margin-top: 2.4em;
	}
`;

export const Button = styled(ThemeButton)`
	padding: 0.2em;
	width: 90%;
	height: 3.56em;
	max-width: 90%;

	@media (orientation: landscape) {
		max-width: 65%;
	}
`;
